// extracted by mini-css-extract-plugin
export default {"chips_wrapper":"chips_wrapper___dqlg1","value_box":"value_box___btkkK","value_text":"value_text___WM7N5","remove_button":"remove_button___mY3QC"};